export default "__VITE_ASSET__3ff7ac59__"